import { DiagnosisRegistrationStoreData } from '@/pages/demands/contexts/diagnosis-registration-store'
import { shpFilesToZip } from '@/utils/file-conversions'

export interface PerimeterAdapterProps {
  selectFilesData: DiagnosisRegistrationStoreData['selectFilesData']
}

export class PerimeterAdapter {
  private selectFilesData

  constructor(props: PerimeterAdapterProps) {
    this.selectFilesData = props.selectFilesData
  }

  async makeFileReference(diagnosisId: string) {
    const perimeterZip = await shpFilesToZip(
      this.selectFilesData!.perimeter!.input,
      {
        type: 'blob',
        filename: this.selectFilesData!.perimeter!.results.filename,
      },
    )

    return {
      file: perimeterZip,
      type: 'perimeter',
      inputType: 'perimeter',
      resumable: false,
      bucketFilename: `${diagnosisId}.zip`,
      originalFilename: `${
        this.selectFilesData!.perimeter!.results.filename
      }.zip`,
    } as const
  }
}
